import { useWatch } from 'react-hook-form';
import { Button } from '@chakra-ui/react';

export default function SearchCNPJButton({ control, index, isValid, ...rest }) {
 const fieldValue = useWatch({
  control,
  name: `form.${index}.cnpj`,
 });

 return (
  <Button
   variant='secondary'
   bg='white'
   color='#0073BB'
   border='1px solid #0073BB'
   w='139px'
   h='49px'
   isDisabled={fieldValue?.length < 18}
   {...rest}
  >
   {isValid ? 'Remover' : 'Pesquisar'}
  </Button>
 );
}
